import { render, staticRenderFns } from "./AllocationDetail.vue?vue&type=template&id=22d9457e&scoped=true&"
import script from "./AllocationDetail.vue?vue&type=script&lang=ts&"
export * from "./AllocationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AllocationDetail.vue?vue&type=style&index=0&id=22d9457e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9457e",
  null
  
)

export default component.exports